<template>
  <div
    :class="value ? variantCls.sliderTrue : variantCls.sliderFalse"
    :tabindex="disabled ? '-1' : '0'"
    @click="onInput"
    @keyup.enter="onInput"
    @focus="emit('focus')"
    @blur="emit('blur')"
  >
    <div
      :style="{
        transform: `translateX(${value ? 100 : 0}%)`,
        transition: `all 150ms ease`
      }"
      :class="value ? variantCls.switchTrue : variantCls.switchFalse"
    />
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "default"
    },
    value: {
      validator(value) {
        return value === null || value === true || value === false
      },
      reguired: true,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    variantCls() {
      return this.$store.getters.variants("JToggle", this.variant).el
    }
  },

  methods: {
    onInput() {
      if (this.disabled) return
      this.$emit("input", !this.value)
    },
    emit(...args) {
      if (!this.disabled) {
        this.$emit(...args)
      }
    }
  }
}
</script>
